var $window = $(window);
var $animation_elements = $('.animation-element');
var swiperTop,sVid,sPlay;
var $bgrwd = $('.k-fig');

$(function () {

    $(document).on("click", 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
        if ($('#header').hasClass('open')){
            $('#header').removeClass('open');
        }
    });

    $(document).on("click", "#btn-menu", function () {
        $('#header').toggleClass('open');
        $(this).toggleClass('active');
    });
    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });

    if ($('#sinit').length != 0) {
        swiperTop = new Swiper('#sinit', {
            init:false,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 600,
            effect: 'fade',
            simulateTouch:true,
            loop: true,
            preloadImages: false,
            lazy: {
               loadPrevNext: true,
               loadPrevNextAmount: 1,
               elementClass:'swiper-lazy',
            }, 
            navigation: {
                nextEl: '.si-next',
                prevEl: '.si-prev',
            },
            autoplay: {
                delay: 6000,
            }
        });
        swiperTop.init();
    }
    if ($('#svideos').length != 0) {
        sVid = new Swiper('#svideos', {
            init:false,
            slidesPerView: 1,
            spaceBetween: 30,
            speed: 600,
            simulateTouch:true,
            loop: false,
            preloadImages: false,
            lazy: {
               loadPrevNext: true,
               loadPrevNextAmount: 1,
               elementClass:'swiper-lazy',
            }, 
            pagination: {
                el: '.sv-pagination',
                clickable: true,
            },
            autoplay: false,
            breakpoints: {
                // when window width is >= 480px
                640: {
                  slidesPerView:2
                },
                960: {
                  slidesPerView:3
                }
            },  
            on: {
                slideChange: function (el) {
                  $('.swiper-slide').each(function () {
                    var youtubePlayer = $(this).find('iframe').get(0);
                    if (youtubePlayer) {
                        youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                    }
                  });
                },
            }
        });
        sVid.init();
    }

    if ($('#splay').length != 0) {
        sPlay = new Swiper('#splay', {
            init:false,
            slidesPerView: 2,
            spaceBetween: 10,
            speed: 600,
            simulateTouch:true,
            loop: false,
            preloadImages: false,
            lazy: {
               loadPrevNext: true,
               loadPrevNextAmount: 1,
               elementClass:'swiper-lazy',
            }, 
            navigation: {
                nextEl: '.sp-next',
                prevEl: '.sp-prev',
            },
            autoplay: {
                delay: 6000,
            },
            breakpoints: {
                // when window width is >= 480px
                640: {
                  slidesPerView:3
                },
                1280: {
                  slidesPerView:4
                }
            }     
        });
        sPlay.init();
    }

    if ($('.s-type').length){
        var $stype=0;
        $(".s-type").each(function() {
            var stType = [];
            $(this).addClass('st'+ $stype).data('count',$stype);

            stType[$stype] = new Swiper('.st'+$stype, {
                slidesPerView: 3,
                slidesPerGroup:3,
                centeredSlides: false,
                spaceBetween:10,
                loop:false,
                watchOverflow:true,
                observer:true,
                keyboard: {
                    enabled: true
                },                    
                preloadImages: false,
                lazy: {
                   loadPrevNext: true,
                   loadPrevNextAmount: 1,
                   elementClass:'swiper-lazy'
                },
                a11y:{
                    enabled:true,
                    prevSlideMessage: 'Mostrar curso anterior',
                    nextSlideMessage:'Mostrar curso siguiente',
                    firstSlideMessage: 'Primer curso',
                    lastSlideMessage: 'Último curso',
                    paginationBulletMessage: 'Mostrar curso {{index}}'                        
                },
                /*navigation: {
                    nextEl: '.sc-next',
                    prevEl: '.sc-prev'
                },*/
                scrollbar: {
                    el: '.st'+$stype+'-scrollbar',
                    draggable: true,
                },
                breakpoints: {
                    // when window width is >= 480px
                    420: {
                      slidesPerView:4,
                      slidesPerGroup:4
                    },
                    520: {
                      slidesPerView:5,
                      slidesPerGroup:5
                    },
                    620: {
                      slidesPerView:6,
                      slidesPerGroup:6
                    },
                    720: {
                      slidesPerView: 7,
                      slidesPerGroup:7
                    },
                    820: {
                      slidesPerView: 8,
                      slidesPerGroup:8
                    },
                    920: {
                      slidesPerView: 9,
                      slidesPerGroup:9
                    },
                    1020: {
                      slidesPerView: 10,
                      slidesPerGroup:10
                    }
                },
                init:false
            });
            stType[$stype].on('init', function() {
                $('.st'+ $stype).addClass('ready');
            }).init();
            $stype = $stype+1;
        });
    };

});

var colors = [
    new $.Color('rgb(0,169,224)'),
    new $.Color('rgb(137,105,188)'),
    new $.Color('rgb(27,111,161)'),
    new $.Color('rgb(89,54,124)'),
    new $.Color('rgb(0,177,230)')
];
$(document).scroll(function() {
    var scroll_pos = $(document).scrollTop();
    var height = $('html').height();
    var body_height = $(window).height();

    var top = scroll_pos * 20 / height;
    $('.rayos').css({'transform' : 'translate(0, -' + top + '%)'});

    var window_bottom_position = (scroll_pos + body_height);
    var $porcImg = -15;

    $('.k-fig').each(function (i) {
        var $element = $(this);
        var element_height = $element.closest('.block').outerHeight();
        var element_top_position = $element.closest('.block').offset().top;
        var element_bot_position = $element.closest('.block').offset().top + element_height;
        $porcImg = -((scroll_pos + body_height/2) - (element_top_position + element_height/2)) * 25 / (body_height/2 + element_height/2);
        if ($porcImg > 25) {
            $porcImg = 25;
        } else if ($porcImg < -25) {
            $porcImg = -25;
        }
        $porcImg = $porcImg+'%';
        $element.css({'transform' : 'translate(0,'+ $porcImg +')'});
    });

    var pos = scroll_pos/(height-body_height);
    pos *= colors.length-1;

    var n = Math.floor(pos);
    var f = pos % 1;
    
    if (n > colors.length-2)
    {
        n = colors.length-2
        f = 1
    }
    
    var color1 = colors[n]
    var color2 = colors[n+1];
    
    var color = new $.Color(
        Math.floor(color1.red()*(1-f) + color2.red()*f),
        Math.floor(color1.green()*(1-f) + color2.green()*f),
        Math.floor(color1.blue()*(1-f) + color2.blue()*f)
    );

    $("body").css("background", color);
}).trigger("scroll");

